export const providerConsents = {
    // ==========================================
    // Common providers (used across QA, UAT, PROD)
    // ==========================================
    'semyazdorovie-gomel': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=semyazdorovie-gomel',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=semyazdorovie-gomel',
    },
    'lubimydoctor-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=lubimydoctor-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=lubimydoctor-minsk',
    },
    'tomography-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=tomography-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=tomography-minsk',
    },
    'aclinica-mogilev': { // Note: QA had a typo 'aclinica-mogilevl' in providerCode, using the code from baseUrl instead
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=aclinica-mogilev',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=aclinica-mogilev',
    },
    'babyboss-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=babyboss-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=babyboss-minsk',
    },
    'alphamed-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },

    // ==========================================
    // Providers mostly used in QA / UAT
    // ==========================================
    'lode-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'lode-grodno': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'lode-brest': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'horizont2-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=horizont2-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=horizont2-minsk',
    },

    // ==========================================
    // PROD providers
    // ==========================================
    'boli-v-spine': { // Extracted from config key, because baseUrl is different (/api/online)
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'kravira-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=kravira-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=kravira-minsk',
    },
    'grandmedica-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'medpractika-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=medpractika-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=medpractika-minsk',
    },
    'proudclinic-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=proudclinic-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=proudclinic-minsk',
    },
    'amadei-gomel': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=amadei-gomel',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=amadei-gomel',
    },
    'unimed-borisov': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=unimed-borisov',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=unimed-borisov',
    },
    'belsono-belarus': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=belsono-belarus',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=belsono-belarus',
    },
    'anatomiya-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=anatomiya-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=anatomiya-minsk',
    },
    'profimed-lida': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=profimed-lida',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=profimed-lida',
    },
    'aksamit-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=aksamit-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=aksamit-minsk',
    },
    'gravita-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=gravita-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=gravita-minsk',
    },
    'grantimed-okomedson-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=grantimed-okomedson-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=grantimed-okomedson-minsk',
    },
    'vinci-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'lifecity-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=lifecity-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=lifecity-minsk',
    },
    'vnuki-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'sevenmed-gomel': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=sevenmed-gomel',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=sevenmed-gomel',
    },
    'doctortut-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=doctortut-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=doctortut-minsk',
    },
    'novolekar-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=novolekar-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=novolekar-minsk',
    },
    'sportmedneo-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=sportmedneo-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=sportmedneo-minsk',
    },
    'womenhealth-grodno': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=womenhealth-grodno',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=womenhealth-grodno',
    },
    'eleos-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'tari-bobruysk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'garmonya-belarus': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=garmonya-belarus',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=garmonya-belarus',
    },
    'medicplus-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=medicplus-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=medicplus-minsk',
    },
    'butterfly-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=butterfly-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=butterfly-minsk',
    },
    'lini-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=lini-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=lini-minsk',
    },
    'medart-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=medart-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=medart-minsk',
    },
    'forestmed-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=forestmed-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=forestmed-minsk',
    },
    'zdorovogosna2-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=zdorovogosna2-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=zdorovogosna2-minsk',
    },
    'eclinic-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'genez-mogilev': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=genez-mogilev',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=genez-mogilev',
    },
    'supramed-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=supramed-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=supramed-minsk',
    },
    'gtfmir-grodno': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=gtfmir-grodno',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=gtfmir-grodno',
    },
    'medstyle-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=medstyle-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=medstyle-minsk',
    },
    'kaskad-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=kaskad-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=kaskad-minsk',
    },
    'expert-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'mako-borisov': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'veanmar-grodno': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=veanmar-grodno',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=veanmar-grodno',
    },
    'medikus-zhodino': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=medikus-zhodino',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=medikus-zhodino',
    },
    'glazkov-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'pediatria-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=pediatria-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=pediatria-minsk',
    },
    'elicato-gomel': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=elicato-gomel',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=elicato-gomel',
    },
    'femineclinic-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=femineclinic-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=femineclinic-minsk',
    },
    'luxestetic-gomel': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=luxestetic-gomel',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=luxestetic-gomel',
    },
    'antesmed-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=antesmed-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=antesmed-minsk',
    },
    'sportlab-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=sportlab-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=sportlab-minsk',
    },
    'lfkano-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=lfkano-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=lfkano-minsk',
    },
    'aclinic-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=aclinic-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=aclinic-minsk',
    },
    'emiclinic-gomel': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=emiclinic-gomel',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=emiclinic-gomel',
    },
    'homoeopathy-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'biovin-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=biovin-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=biovin-minsk',
    },
    'simed-rechytsa': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=simed-rechytsa',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=simed-rechytsa',
    },
    'maivamed-vitebsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'restart-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=restart-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=restart-minsk', // empty page(no doc)
    },
    'egodent-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=egodent-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=egodent-minsk',
    },
    'vokadent-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'anvimed-grodno': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=anvimed-grodno',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=anvimed-grodno',
    },
    'kosmomedlux-mogilev': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=kosmomedlux-mogilev',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=kosmomedlux-mogilev',
    },
    'zdorovogosna-brest': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=zdorovogosna-brest',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=zdorovogosna-brest',
    },
    'virosal-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=virosal-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=virosal-minsk',
    },
};
